import agent from './agent'

export const BankCode = {
  get: async () => {
    return new Promise((resolve, reject) => {
      return agent.Request.get(`/bankCode`)
        .then(response => resolve(response))
    })
  },
}